module.exports = __webpack_public_path__ + "static/image_8_thumb-be86eb9d5350bde27b6cd73bb67860e1.jpg";